import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        bookingId: Number,
        paymentId: Number,
        litigantId: Number,
        litigantName: String,
    };

    capture(event) {
        event.preventDefault();
        event.stopPropagation();

        showPreloader();

        const feedbackCashingModalController = this.application.getControllerForElementAndIdentifier(
            document.getElementById('payment-feedback-cashing-modal'),
            'payment--feedback-cashing-modal'
        );

        if (this.litigantIdValue) {
            feedbackCashingModalController.litigantIdValue = this.litigantIdValue;
            feedbackCashingModalController.litigantNameValue = this.litigantNameValue;
        }

        feedbackCashingModalController.paymentIdValue = this.paymentIdValue;
        feedbackCashingModalController.bookingIdValue = this.bookingIdValue;
        feedbackCashingModalController.open();

        $.ajax(routes['app_payments_capture'].replace('__id__', this.paymentIdValue), {}, result => {
            const $form = $(result);

            $('body').append($form);

            $form.submit();
        }).fail(() => {
            hidePreloader();
        });
    }

    refund(event) {
        event.preventDefault();
        event.stopPropagation();

        const refundModalController = this.application.getControllerForElementAndIdentifier(
            document.getElementById('payment-refund-modal'),
            'payment--refund-modal'
        );

        refundModalController.paymentIdValue = this.paymentIdValue;
        refundModalController.open();
    }

    cancelPreAuthorization(event) {
        event.preventDefault();
        event.stopPropagation();

        showPreloader();

        $.ajax(routes['app_payments_preauthorizationcancel'].replace('__id__', this.paymentIdValue), {}, result => {
            const $form = $(result);

            $('body').append($form);

            $form.submit();
        }).fail(() => {
            hidePreloader();
        });
    }
}
